import util from '../util'

let controller = 'ArquivoRetornoCNAB'

export default Object.assign({}, util.GetCrud(controller,
  ['get', 'getall']
), {
  Download: (dto) => {
    return util.Axios.PostBlob(controller + '/Download', dto)
  },
  RecebimentoArqCnab: function (dto) {
    return util.Axios.GetAll(controller + '/Recebimento/ArqCnab', dto)
  }
})
